"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.active.help': 'Abilita questa conoscenza per l\'uso',
};
